export enum TwoFAEvents {
  ERROR = 'error',
  CREATE_ORDER = 'create_order',
}

export enum CardinalEvents {
  SETUP_COMPLETE = 'payments.setupComplete',
  VALIDATED = 'payments.validated',
}

export enum CardinalValidatedActionCodes {
  SUCCESS = 'SUCCESS',
  NOACTION = 'NOACTION',
  FAILURE = 'FAILURE',
  ERROR = 'ERROR',
}

export enum CardinalPaymentBrand {
  CCA = 'cca', // Cardinal Consumer Authentication
}

export enum CybersourceResponseCodes {
  DAUTHENTICATE = '475', // The cardholder is enrolled in Payer Authentication. Please authenticate the cardholder before continuing with the transaction.
  SOK = '100', // Successful transaction
  // Other codes represents declined transactions. See details here: https://support.cybersource.com/s/article/What-does-this-response-code-mean
}
